import { render, staticRenderFns } from "./SegmentDropdown.vue?vue&type=template&id=ebe5dcfe&scoped=true"
import script from "./SegmentDropdown.vue?vue&type=script&lang=js"
export * from "./SegmentDropdown.vue?vue&type=script&lang=js"
import style0 from "./SegmentDropdown.vue?vue&type=style&index=0&id=ebe5dcfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe5dcfe",
  null
  
)

export default component.exports